module.exports = __webpack_public_path__ + "img/Terraform-1.c83da64f.png";